const throwIfUndefined = (value: Object, errorText: () => string) => {
    if (value === undefined) {
        throw Error(`throwIfUndefined; ${errorText()}`);
    }

};

const throwIfTrue = (value: boolean | undefined, errorText: () => string) => {
    if (value === true) {
        throw Error(`throwIfTrue; ${errorText()}`);
    }

};

const AppException = {
    throwIfUndefined,
    throwIfTrue
}

export default AppException;
